import notificationService from '@app/services/notificationService'

import { errorDescription, errorMessage } from '@app/constants/errorNotification'

import { responseStatus } from '@app/constants/responseStatus'

import type { AxiosError, AxiosInstance } from 'axios'
import type { ErrorResponseDto } from '../dtos'

interface PushErrorOptions {
  message?: string
  description?: unknown
}

const handleErrorNotification = async (error: AxiosError<ErrorResponseDto>): Promise<AxiosError> => {
  const pushError = ({
    message = errorMessage.ERROR,
    description = errorDescription.DEFAULT
  }: PushErrorOptions = {}): void => {
    notificationService.error({
      message,
      description: formatErrorDescription(description)
    })
  }

  const { response } = error

  if (response) {
    const { status, data } = response

    const { detail: description } = data

    switch (status) {
      case responseStatus.BAD_REQUEST:
        pushError({ description })
        break
      // TODO: потом доработать, чтобы не игнорировало все 401 ошибки
      case responseStatus.UNAUTHORIZED:
        // pushError({ description })
        break
      case responseStatus.FORBIDDEN:
        pushError({ description })
        break
      case responseStatus.NOT_FOUND:
        pushError({ description })
        break
      case responseStatus.UNPROCESSABLE_CONTENT:
        break
      case responseStatus.INTERNAL_SERVER_ERROR:
        pushError({ description })
        break
      default:
        pushError()
    }
  } else {
    pushError({ message: 'Ошибка сервера:', description: error.message })
  }

  throw error
}

const formatErrorDescription = (description: any): string => {
  if (typeof description === 'string') return description

  if (typeof description === 'object' && description !== null) {
    if (Array.isArray(description)) {
      return description.map(item => String(item)).join('\n')
    }

    const formattedParts: string[] = []

    for (const [key, value] of Object.entries(description)) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          const stringValues = value.map(item => String(item))
          formattedParts.push(`${key}: ${stringValues.join(', ')}`)
        }
        continue
      }

      if (value !== null && value !== undefined && value !== '') {
        formattedParts.push(`${key}: ${String(value)}`)
      }
    }

    return formattedParts.join('\n') || 'Неизвестная ошибка'
  }

  return String(description)
}

const applyErrorNotification = (api: AxiosInstance): void => {
  api.interceptors.response.use(response => response, handleErrorNotification)
}

export default applyErrorNotification
